// extracted by mini-css-extract-plugin
export default {"ActivityPromotion":"ActivityPromotion_ActivityPromotion__djBDd","list__title":"ActivityPromotion_list__title__YJwBO","list__body":"ActivityPromotion_list__body__TPO3e"};